const GA_MEASUREMENT_ID = "G-QD02ZT5HBK";
const CONSENT_STORAGE_KEY = "ma_galaxy_cookie_consent"; // "accepted" | "declined"

export function getStoredConsent() {
  try {
    return window.localStorage.getItem(CONSENT_STORAGE_KEY);
  } catch {
    // Storage unavailable (private browsing, disabled storage, etc.) — treat
    // as "no choice made yet" so the banner shows and asks every time.
    return null;
  }
}

export function setStoredConsent(value) {
  try {
    window.localStorage.setItem(CONSENT_STORAGE_KEY, value);
  } catch {
    // Choice just won't persist across visits; not fatal.
  }
}

let analyticsLoaded = false;

// Injects gtag.js and fires the initial config call. index.html deliberately
// does NOT load gtag.js itself — this is the only code path that does, and
// it only ever runs after real consent (a stored "accepted" choice from a
// previous visit, or a fresh click on Accept in CookieConsentBanner).
export function loadAnalytics() {
  if (analyticsLoaded || typeof window === "undefined") return;
  analyticsLoaded = true;

  window.dataLayer = window.dataLayer || [];
  window.gtag = function gtag() {
    window.dataLayer.push(arguments);
  };
  window.gtag("js", new Date());
  window.gtag("config", GA_MEASUREMENT_ID);

  const script = document.createElement("script");
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_MEASUREMENT_ID}`;
  document.head.appendChild(script);
}
